import React, { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

const questions = [
  {
    question: "How do I upgrade my plan?",
    answer:
      "To upgrade your plan, simply click the 'Upgrade Now' button next to your desired plan. You'll be guided through the process to update your subscription.",
  },
  {
    question: "Can I change my plan later?",
    answer:
      "Yes, you can upgrade, downgrade, or cancel your plan at any time. Changes will be reflected in your next billing cycle.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit cards, PayPal, and bank transfers for Enterprise plans.",
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="px-4 sm:px-6 md:px-8 py-6 sm:py-8 md:py-10">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold font-inter mb-4 sm:mb-6">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4 sm:space-y-6">
        {questions.map((item, index) => (
          <div key={index} className="w-full">
            <button
              className="w-full text-left p-4 sm:p-5 bg-white transition duration-200 shadow-lg border border-gray-100 rounded-xl focus:outline-none"
              onClick={() => toggleAnswer(index)}
            >
              <div className="flex justify-between items-center w-full">
                <span className="text-base sm:text-xl md:text-2xl font-inter font-semibold pr-4">
                  {item.question}
                </span>
                <IoMdArrowDropdown
                  className={`flex-shrink-0 text-black w-6 h-6 sm:w-8 sm:h-8 transition-transform ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </div>
              {openIndex === index && (
                <div className="pt-3 sm:pt-4 w-full text-sm sm:text-base md:text-xl font-inter text-gray-700">
                  {item.answer}
                </div>
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
